import axios from 'axios'
import {
  ERROR_400,
  EXCEPTION,
  ERROR_401
} from '../redux/types'

export default (config, type) => {
  let headers = config.headers || {}

  Object.assign(headers, {
    'target': 'API',
    'csrf-token': window.config.csrf
  })

  Object.assign(config, {
    headers,
    withCredentials: true,
    validateStatus(status) {
      return status >= 200 && status < 500
    }
  })

  return axios(config)
    .then(result => {
      if (result.status >= 400) {
        result.data.status = result.status
        return {
          type: result.status === 401 ? ERROR_401 : ERROR_400,
          payload: result.data
        }
      }

      return { type, payload: result.data }
    }).catch(err => {
      console.warn(err)
      return {
        type: EXCEPTION,
        payload: { message: 'Network Error' }
      }
    })
}



// WEBPACK FOOTER //
// ./src/utils/axios.js